module.exports = {"annual":"jaarlijks","daily":"dagelijks","monthly":"maandelijks","none":"geen","weekly":"wekelijks"}